// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-check[data-v-11cd442f]{position:relative;top:30px}", "",{"version":3,"sources":["webpack://./resources/js/Components/Organizations/forms/organization-config.vue"],"names":[],"mappings":"AACA,+BACE,iBAAA,CACA,QAAF","sourcesContent":["\n.custom-check {\n  position: relative;\n  top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
